import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_DiagnosticAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_DiagnosticAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p>
                    <span className='eleHeader'>Date:</span>
                    <input type="date" id="txtDate" name="txtDate" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>1). Mental Status Examination:</span>
                    <span className='small'>(Check all items that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><strong>Orientation:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Orientation_1" /> Person
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Orientation_2" /> Place
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Orientation_3" /> Time
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Orientation_4" /> Situation
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Appearance:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className='add-only' value="Appearance_1" />Neat
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className='add-only' value="Appearance_2" />Fastidious
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_3" name="cbAppearance_3" className='add-only' value="Appearance_3" />Casual
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_4" name="cbAppearance_4" className='add-only' value="Appearance_4" />Flamboyant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_5" name="cbAppearance_5" className='add-only' value="Appearance_5" />Bizarre
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_6" name="cbAppearance_6" className='add-only' value="Appearance_6" />Disheveled
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Demeanor:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_1" name="cbDemeanor_1" className='add-only' value="Demeanor_1" />Demanding
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_2" name="cbDemeanor_2" className='add-only' value="Demeanor_2" />Friendly
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_3" name="cbDemeanor_3" className='add-only' value="Demeanor_3" />Hostile
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_4" name="cbDemeanor_4" className='add-only' value="Demeanor_4" />Manipulative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_5" name="cbDemeanor_5" className='add-only' value="Demeanor_5" />Negative
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_6" name="cbDemeanor_6" className='add-only' value="Demeanor_6" />Aloof
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_7" name="cbDemeanor_7" className='add-only' value="Demeanor_7" />Anxious
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Movement/Mood:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMovement_1" name="cbMovement_1" className='add-only' value="Movement_1" />Euthymic
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMovement_2" name="cbMovement_2" className='add-only' value="Movement_2" />Elevated
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMovement_3" name="cbMovement_3" className='add-only' value="Movement_3" />Dysphoric
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMovement_4" name="cbMovement_4" className='add-only' value="Movement_4" />Tics
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMovement_5" name="cbMovement_5" className='add-only' value="Movement_5" />Tremors
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Affect:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="Affect_1" />Full range
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="Affect_2" />Constricted
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="Affect_3" />Labile
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="Affect_4" />Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="Affect_5" />Blunted
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="Affect_6" />Flat
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Speech:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Speech_1" />WNL
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Speech_2" />Hyperverbal
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Speech_3" />Pressure speech
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Speech_4" />Slow
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Speech_5" />Soft
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Speech_6" />Loud
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Thought Processes:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_1" name="cbThoughtProcesses_1" className='add-only' value="ThoughtProcesses_1" />Goal directed
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_2" name="cbThoughtProcesses_2" className='add-only' value="ThoughtProcesses_2" />Linear
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_3" name="cbThoughtProcesses_3" className='add-only' value="ThoughtProcesses_3" />FOI
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_4" name="cbThoughtProcesses_4" className='add-only' value="ThoughtProcesses_4" />Tangential
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_5" name="cbThoughtProcesses_5" className='add-only' value="ThoughtProcesses_5" />Circumstantial
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_6" name="cbThoughtProcesses_6" className='add-only' value="ThoughtProcesses_6" />Racing thoughts
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_7" name="cbThoughtProcesses_7" className='add-only' value="ThoughtProcesses_7" />Blocking
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcesses_8" name="cbThoughtProcesses_8" className='add-only' value="ThoughtProcesses_8" />Perseveration
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Thought Content:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_1" name="cbThoughtContent_1" className='add-only' value="ThoughtContent_1" />Logical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_2" name="cbThoughtContent_2" className='add-only' value="ThoughtContent_2" />Delusions
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_3" name="cbThoughtContent_3" className='add-only' value="ThoughtContent_3" />Obsessions
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_4" name="cbThoughtContent_4" className='add-only' value="ThoughtContent_4" />Compulsions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_5" name="cbThoughtContent_5" className='add-only' value="ThoughtContent_5" />Ideas of reference
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_6" name="cbThoughtContent_6" className='add-only' value="ThoughtContent_6" />Phobia
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_7" name="cbThoughtContent_7" className='add-only' value="ThoughtContent_7" />Preoccupation
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_8" name="cbThoughtContent_8" className='add-only' value="ThoughtContent_8" />Paranoia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_9" name="cbThoughtContent_9" className='add-only' value="ThoughtContent_9" />AH
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtContent_10" name="cbThoughtContent_10" className='add-only' value="ThoughtContent_10" />VH
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Insight/Judgment:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="Insight_1" />Good
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Insight_2" />Fair
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Insight_3" />Poor
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2). Presenting Problems:</span>
                            Pls indicate if  client present any of the following:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_1" name="cbPresentingProblems_1" className='add-only' value="PresentingProblems_1" />Defiance
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_2" name="cbPresentingProblems_2" className='add-only' value="PresentingProblems_2" />Opposition
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_3" name="cbPresentingProblems_3" className='add-only' value="PresentingProblems_3" />Drugs
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_4" name="cbPresentingProblems_4" className='add-only' value="PresentingProblems_4" />Alcohol
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_5" name="cbPresentingProblems_5" className='add-only' value="PresentingProblems_5" />Lies
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_6" name="cbPresentingProblems_6" className='add-only' value="PresentingProblems_6" />Runaway
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_7" name="cbPresentingProblems_7" className='add-only' value="PresentingProblems_7" /> School Disruptions
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_8" name="cbPresentingProblems_8" className='add-only' value="PresentingProblems_8" />Promiscuity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_9" name="cbPresentingProblems_9" className='add-only' value="PresentingProblems_9" />Stealing
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPresentingProblems_10" name="cbPresentingProblems_10" className='add-only' value="PresentingProblems_10" />Poor Grades
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbPresentingProblems_11" name="cbPresentingProblems_11" className='add-only' value="PresentingProblems_11" />Physical fights w/parents
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPresentingProblems_12" name="cbPresentingProblems_12" className='add-only' value="PresentingProblems_12" />Other (Pls indicate)
                            <input type="text" id="txtPresentingProblems_12" name="txtPresentingProblems_12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Depressive Symptoms: :</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_1" name="cbDepressiveSymptoms_1" className='add-only' value="DepressiveSymptoms_1" />Denied
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_2" name="cbDepressiveSymptoms_2" className='add-only' value="DepressiveSymptoms_2" />Depressed Mood
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_3" name="cbDepressiveSymptoms_3" className='add-only' value="DepressiveSymptoms_3" />Sleep Problems
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_4" name="cbDepressiveSymptoms_4" className='add-only' value="DepressiveSymptoms_4" />Poor Appetite
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_5" name="cbDepressiveSymptoms_5" className='add-only' value="DepressiveSymptoms_5" />Poor Energy
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_6" name="cbDepressiveSymptoms_6" className='add-only' value="DepressiveSymptoms_6" />Guilt
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_7" name="cbDepressiveSymptoms_7" className='add-only' value="DepressiveSymptoms_7" />Hopeless
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_8" name="cbDepressiveSymptoms_8" className='add-only' value="DepressiveSymptoms_8" />Anhedonia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_9" name="cbDepressiveSymptoms_9" className='add-only' value="DepressiveSymptoms_9" />Social Isolation
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_10" name="cbDepressiveSymptoms_10" className='add-only' value="DepressiveSymptoms_10" />SI
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_11" name="cbDepressiveSymptoms_11" className='add-only' value="DepressiveSymptoms_11" />with intent
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDepressiveSymptoms_12" name="cbDepressiveSymptoms_12" className='add-only' value="DepressiveSymptoms_12" />Cutting
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Manic Symptoms:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbManicSymptoms_1" name="cbManicSymptoms_1" className='add-only' value="ManicSymptoms_1" />Denied
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbManicSymptoms_2" name="cbManicSymptoms_2" className='add-only' value="ManicSymptoms_2" />Racing thoughts
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbManicSymptoms_3" name="cbManicSymptoms_3" className='add-only' value="ManicSymptoms_3" />Decreased need for sleep
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbManicSymptoms_4" name="cbManicSymptoms_4" className='add-only' value="ManicSymptoms_4" />Increased goal directed activity
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbManicSymptoms_5" name="cbManicSymptoms_5" className='add-only' value="ManicSymptoms_5" />Mood Swings
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbManicSymptoms_6" name="cbManicSymptoms_6" className='add-only' value="ManicSymptoms_6" />Euphoria
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbManicSymptoms_7" name="cbManicSymptoms_7" className='add-only' value="ManicSymptoms_7" />Pressured Speech
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>ADHD Symptoms::</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_1" name="cbAdhd_1" className='add-only' value="Adhd_1" />Denied
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_2" name="cbAdhd_2" className='add-only' value="Adhd_2" />Losing things
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_3" name="cbAdhd_3" className='add-only' value="Adhd_3" />Forgetful
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_4" name="cbAdhd_4" className='add-only' value="Adhd_4" />Impulsivity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_5" name="cbAdhd_5" className='add-only' value="Adhd_5" />Problems finishing tasks
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_6" name="cbAdhd_6" className='add-only' value="Adhd_6" />Blurting out
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_7" name="cbAdhd_7" className='add-only' value="Adhd_7" />Interrupting
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_8" name="cbAdhd_8" className='add-only' value="Adhd_8" />Impatience
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_9" name="cbAdhd_9" className='add-only' value="Adhd_9" />Inattentiveness
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_10" name="cbAdhd_10" className='add-only' value="Adhd_10" />Fidgety
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_11" name="cbAdhd_11" className='add-only' value="Adhd_11" />Distractibility
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_12" name="cbAdhd_12" className='add-only' value="Adhd_12" />Hyperactivity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdhd_13" name="cbAdhd_13" className='add-only' value="Adhd_13" />Problems sitting still
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>PTSD Symptoms:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPtsd_1" name="cbPtsd_1" className='add-only' value="Ptsd_1" />Denied
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPtsd_2" name="cbPtsd_2" className='add-only' value="Ptsd_2" />Nightmares
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPtsd_3" name="cbPtsd_3" className='add-only' value="Ptsd_3" />Flashbacks
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPtsd_4" name="cbPtsd_4" className='add-only' value="Ptsd_4" />Dissociation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPtsd_5" name="cbPtsd_5" className='add-only' value="Ptsd_5" />Startle
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPtsd_6" name="cbPtsd_6" className='add-only' value="Ptsd_6" />Avoidance
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPtsd_7" name="cbPtsd_7" className='add-only' value="Ptsd_7" />Intrusive thoughts
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Violence:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbViolence_1" name="cbViolence_1" className='add-only' value="Violence_1" />Fighting
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbViolence_2" name="cbViolence_2" className='add-only' value="Violence_2" />HI
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbViolence_3" name="cbViolence_3" className='add-only' value="Violence_3" />Denied
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><strong>Psychosis:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPsychosis_1" name="cbPsychosis_1" className='add-only' value="Psychosis_1" />Denied
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPsychosis_2" name="cbPsychosis_2" className='add-only' value="Psychosis_2" />AH
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPsychosis_3" name="cbPsychosis_3" className='add-only' value="Psychosis_3" />VH
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPsychosis_4" name="cbPsychosis_4" className='add-only' value="Psychosis_4" />Delusions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPsychosis_5" name="cbPsychosis_5" className='add-only' value="Psychosis_5" />Paranoia
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPsychosis_6" name="cbPsychosis_6" className='add-only' value="Psychosis_6" />Disorganized
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychosis_7" name="cbPsychosis_7" className='add-only' value="Psychosis_7" />Other (Pls specify):
                            <input type="text" id="txtPsychosis_7" name="txtPsychosis_7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>3). Medical Hx:</span>
                    <span className='small'>(List below):</span>
                    <input type="checkbox" id="cbMedicalHx_None" name="cbMedicalHx_None" className='add-only' value="MedicalHx_None" />None reported
                    <br />
                    <textarea id="txtMedicalHx_None" name="txtMedicalHx_None" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Medication:</span>
                    <span className='small'>(List below):</span>
                    <input type="checkbox" id="cbMedication_None" name="cbMedication_None" className='add-only' value="Medication_None" />None reported
                    <br />
                    <textarea id="txtMedication_None" name="txtMedication_None" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Allergies:</span>
                    <input type="checkbox" id="cbAllergies_None" name="cbAllergies_None" className='add-only' value="Allergies_None" />None reported
                    <br />
                    <textarea id="txtAllergies_None" name="txtAllergies_None" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4). Residence:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbResidence_1" name="cbResidence_1" className='add-only' value="Residence_1" />Family (including extended)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbResidence_2" name="cbResidence_2" className='add-only' value="Residence_2" />Parent/Guardian
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbResidence_3" name="cbResidence_3" className='add-only' value="Residence_3" />Personal Care Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbResidence_4" name="cbResidence_4" className='add-only' value="Residence_4" />Homeless
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbResidence_5" name="cbResidence_5" className='add-only' value="Residence_5" />
                            Other (Pls Specify)
                            <input type="text" id="txtResidence_5" name="txtResidence_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>5). School Hx:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Grade Level:<input type="text" id="txtGradeLevel" name="txtGradeLevel" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSchoolHx_1" name="cbSchoolHx_1" className='add-only' value="SchoolHx_1" />Repeat grade
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSchoolHx_2" name="cbSchoolHx_2" className='add-only' value="SchoolHx_2" />Special classes
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSchoolHx_3" name="cbSchoolHx_3" className='add-only' value="SchoolHx_3" />Suspensions
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSchoolHx_4" name="cbSchoolHx_4" className='add-only' value="SchoolHx_4" />Expulsion
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6). Substance Abuse Hx:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_1" name="cbSubstanceAbuse_1" className='add-only' value="SubstanceAbuse_1" />Denied
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_2" name="cbSubstanceAbuse_2" className='add-only' value="SubstanceAbuse_2" />Marijuana
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_3" name="cbSubstanceAbuse_3" className='add-only' value="SubstanceAbuse_3" />ETOH
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_4" name="cbSubstanceAbuse_4" className='add-only' value="SubstanceAbuse_4" />Crystal Methamphetamine
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_5" name="cbSubstanceAbuse_5" className='add-only' value="SubstanceAbuse_5" />MDMA
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_6" name="cbSubstanceAbuse_6" className='add-only' value="SubstanceAbuse_6" />Stimulants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_7" name="cbSubstanceAbuse_7" className='add-only' value="SubstanceAbuse_7" />PCP
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_8" name="cbSubstanceAbuse_8" className='add-only' value="SubstanceAbuse_8" />LSD
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_9" name="cbSubstanceAbuse_9" className='add-only' value="SubstanceAbuse_9" />Ketamine
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_10" name="cbSubstanceAbuse_10" className='add-only' value="SubstanceAbuse_10" />Heroin
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_11" name="cbSubstanceAbuse_11" className='add-only' value="SubstanceAbuse_11" />Cocaine
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_12" name="cbSubstanceAbuse_12" className='add-only' value="SubstanceAbuse_12" />Inhalants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_13" name="cbSubstanceAbuse_13" className='add-only' value="SubstanceAbuse_13" />Hashish
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_14" name="cbSubstanceAbuse_14" className='add-only' value="SubstanceAbuse_14" />Mushrooms
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_15" name="cbSubstanceAbuse_15" className='add-only' value="SubstanceAbuse_15" />Oxycontin
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_16" name="cbSubstanceAbuse_16" className='add-only' value="SubstanceAbuse_16" />Benzodiazepines
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceAbuse_17" name="cbSubstanceAbuse_17" className='add-only' value="SubstanceAbuse_17" />
                            Other (Pls Specify)
                            <input type="text" id="txtSubstanceAbuse_17" name="txtSubstanceAbuse_17" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7). Legal Hx:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_1" name="cbLegalHx_1" className='add-only' value="LegalHx_1" />Denied
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_2" name="cbLegalHx_2" className='add-only' value="LegalHx_2" />Violation of probation
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_3" name="cbLegalHx_3" className='add-only' value="LegalHx_3" />Unruly child
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_4" name="cbLegalHx_4" className='add-only' value="LegalHx_4" />Runaway
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_5" name="cbLegalHx_5" className='add-only' value="LegalHx_5" />Drug possession
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_6" name="cbLegalHx_6" className='add-only' value="LegalHx_6" />Selling drugs
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_7" name="cbLegalHx_7" className='add-only' value="LegalHx_7" />Battery
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_8" name="cbLegalHx_8" className='add-only' value="LegalHx_8" />Assault
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_9" name="cbLegalHx_9" className='add-only' value="LegalHx_9" />Burglary/theft
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_10" name="cbLegalHx_10" className='add-only' value="LegalHx_10" />Probation
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_11" name="cbLegalHx_11" className='add-only' value="LegalHx_11" />School disruption
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_12" name="cbLegalHx_12" className='add-only' value="LegalHx_12" />Trespass
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalHx_13" name="cbLegalHx_13" className='add-only' value="LegalHx_13" />Truancy
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>8).  Summary: </span>
                    Current reported sxs/bxs include
                    <br />
                    <textarea id="txtSummary" name="txtSummary" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>9). Diagnosis: DSM 5/ICD 10</span>
                    <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Z Code(Psychosocial Stressor)</span>
                    <textarea id="txtZcode" name="txtZcode" className='add-only'></textarea>
                </p>



            </div>
        </form>

    )
}